<ng-container *ngIf="status$ | async | ready as feature">
  <button
    *ngIf="feature.properties?.online?.value"
    data-at-reboot-gateway-btn
    mat-menu-item
    [viConfirm]="{
      title: '+INSTALLATIONS.INSTALLATION.GATEWAY.REBOOT.DIALOG.TITLE' | translate,
      content: '+INSTALLATIONS.INSTALLATION.GATEWAY.REBOOT.DIALOG.MESSAGE' | translate,
      cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
      confirmBtn: 'GENERAL.BUTTON.REBOOT' | translate
    }"
    gtm="onOpen"
    gtmAction="Reboot gateway modal"
    gtmCategory="gateway"
    (confirm)="rebootGateway()"
    (cancel)="cancelRebootGatewayConfirmation()"
    [attr.data-feature]="feature.feature + '/online'"
  >
    {{ 'GENERAL.BUTTON.REBOOT' | translate }}
  </button>
</ng-container>
<button
  *appHideForUserRole="UserRoleType.supportLocalReadOnly"
  data-at-refresh-device-list
  mat-menu-item
  [viConfirm]="{
    title: '+INSTALLATIONS.INSTALLATION.GATEWAY.REFRESH_DEVICE_LIST.DIALOG.TITLE' | translate,
    content: '+INSTALLATIONS.INSTALLATION.GATEWAY.REFRESH_DEVICE_LIST.DIALOG.MESSAGE' | translate,
    cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
    confirmBtn: 'GENERAL.BUTTON.REFRESH_DEVICE_LIST' | translate
  }"
  gtm="onOpen"
  gtmAction="Refresh device list modal"
  gtmCategory="gateway"
  (confirm)="refreshDeviceList()"
  (cancel)="cancelRefreshDeviceListConfirmation()"
>
  {{ 'GENERAL.BUTTON.REFRESH_DEVICE_LIST' | translate }}
</button>
<button
  data-at-replace-gateway
  mat-menu-item
  gtm="onOpen"
  gtmAction="Replace Gateway modal"
  gtmCategory="gateway"
  (click)="openReplaceGatewayModal()"
  class="replace-gateway"
>
  <span>{{ '+INSTALLATIONS.INSTALLATION.GATEWAY.MENU.REPLACE_GATEWAY' | translate }}</span>
</button>
<ng-container *ngIf="installationDetailsStore.isMultigatewayInstallation$ | async">
  <button
    *appShowForRsaRoles="rsaRolesForDeregister"
    data-at-deregister-gateway
    mat-menu-item
    gtm="onOpen"
    gtmAction="Deregister gateway modal"
    gtmCategory="gateway"
    (click)="openDeregisterConfirmationModal(gatewaySerial)"
    class="deregister"
  >
    <span>{{ '+INSTALLATIONS.INSTALLATION.GATEWAY.MENU.DEREGISTER_GATEWAY' | translate }}</span>
  </button>
</ng-container>
<button
  *appShowForRsaRoles="rsaRolesForDeregister"
  data-at-deregister-installation
  mat-menu-item
  gtm="onOpen"
  gtmAction="Deregister installation modal"
  gtmCategory="gateway"
  (click)="openDeregisterConfirmationModal()"
  class="deregister"
>
  <span>{{ '+INSTALLATIONS.INSTALLATION.GATEWAY.MENU.DEREGISTER_INSTALLATION' | translate }}</span>
</button>
